import { CollapsibleSection } from "components/collapsibleSection";
import Input from "components/input";
import { Label } from "components/label";
import { Tag } from "components/tag";
import Textarea from "components/textarea";
import { DiscountType, IPromotionConditionDetail } from "interfaces";
import { formatNumber, getPaymentMethodLabel } from "utills/helpers";
interface AdditionalSetupProps {
  conditionDetailData: IPromotionConditionDetail;
}
export const ViewConditionAdditionalSetup = ({
  conditionDetailData,
}: AdditionalSetupProps) => {
  const shouldShowPaymentMethods = () => {
    const discountTypeForPaymentMethods = [
      DiscountType.FIX_PRICE,
      DiscountType.PERCENT,
      DiscountType.QUANTITY_DISCOUNT,
      DiscountType.CAMPAIGN_DISCOUNT,
    ];
    return discountTypeForPaymentMethods.includes(
      conditionDetailData?.discount_type_display
    );
  };

  const shouldShowUsagePerAccount = () => {
    const discountTypeForUsagePerAccount = [
      DiscountType.FIX_PRICE,
      DiscountType.PERCENT,
    ];
    return discountTypeForUsagePerAccount.includes(
      conditionDetailData?.discount_type_display
    );
  };

  const shouldShowDailyActiveTime = () => {
    const discountTypeForDailyActiveTime = [
      DiscountType.FIX_PRICE,
      DiscountType.PERCENT,
    ];
    return discountTypeForDailyActiveTime.includes(
      conditionDetailData?.discount_type_display
    );
  };

  return (
    <CollapsibleSection label="Additional Set-up" defaultOpen={false}>
      <div className="box-container">
        <div className="grid gap-x-4 gap-y-4 grid-cols-8 text-sm">
          <div className="col-span-full">
            <Label required id="max_times_used" name="Max Time To Use" />
            <p>{formatNumber(conditionDetailData?.max_times_used ?? 0)}</p>
          </div>
          {shouldShowPaymentMethods() && (
            <div className="col-span-full sm:col-span-4">
              <Input
                type="checkbox"
                label="Payment Methods"
                id="isShowPaymentMethod"
                checked={conditionDetailData?.apply_to_payment_methods}
                disabled
              />
              {conditionDetailData?.apply_to_payment_methods && (
                <div className="mt-4">
                  <div className="flex items-center flex-wrap gap-2.5">
                    {(conditionDetailData?.apply_to_payment_methods ?? []).map(
                      (method) => (
                        <Tag
                          text={
                            method === "all"
                              ? "All"
                              : getPaymentMethodLabel(method)
                          }
                          key={method}
                        />
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          {shouldShowUsagePerAccount() && (
            <div className="col-span-full sm:col-span-4">
              <Input
                type="checkbox"
                label="Max Usage Per Account"
                id="isShowUsagePerAccount"
                checked={conditionDetailData?.max_times_used_per_account}
                disabled
              />
              {conditionDetailData?.max_times_used_per_account && (
                <div className="mt-4">
                  <p>{conditionDetailData?.max_times_used_per_account}</p>
                </div>
              )}
            </div>
          )}
          {shouldShowDailyActiveTime() && (
            <div className="col-span-full">
              <Input
                type="checkbox"
                label="Daily Active Time"
                id="isShowDailyActiveTime"
                checked={
                  conditionDetailData?.apply_from_hour ||
                  conditionDetailData?.apply_to_hour ||
                  conditionDetailData?.max_times_used_per_day
                }
                disabled
              />
              {(conditionDetailData?.apply_from_hour ||
                conditionDetailData?.apply_to_hour ||
                conditionDetailData?.max_times_used_per_day) && (
                <div className="w-full mt-4 flex flex-col sm:flex-row gap-4">
                  <div className="flex-1">
                    <Label
                      required
                      id="apply_from_hour"
                      name="Daily Start Time"
                    />
                    <p>{conditionDetailData?.apply_from_hour}</p>
                  </div>
                  <div className="flex-1">
                    <Label required id="apply_to_hour" name="Daily End Time" />
                    <p>{conditionDetailData?.apply_to_hour}</p>
                  </div>
                  <div className="flex-1">
                    <Label
                      id="max_times_used_per_day"
                      name="Daily Usage Limit"
                    />
                    <p>{conditionDetailData?.max_times_used_per_day}</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </CollapsibleSection>
  );
};
